import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import PlanUsageLogTable from "./planUsageLog-table/PlanUsageLogTable";

export const PlanUsageLogCard = () => {
  return (
    <Card>
      <CardHeader title="Riwayat Penggunaan"></CardHeader>
      <CardBody>
        <PlanUsageLogTable />
      </CardBody>
    </Card>
  );
};
